// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1a319514","301":"b3893b68"}[chunkId] + ".chunk.js";
};